<template>
  <div class="staged-rollout">
    <span class="staged-rollout__label-text">
      {{ this.$t('APP.RELEASES.STAGED_ROLLOUT') }}
    </span>

    <Hint :message="$t('APP.RELEASES.STAGED_ROLLOUT.HELP')" />

    <span
      v-if="disabled && showDisabledMessage"
      class="show-for-medium staged-rollout__alert"
    >
      {{ this.$t('APP.RELEASES.STAGED_ROLLOUT.INSTALLS_LIMIT') }}
    </span>

    <StagedRolloutSlider
      v-if="!disabled"
      class="staged-rollout__slider"
      v-bind="$attrs"
      :percentage.sync="localPercentage"
    />
    <span
      v-if="disabled && showDisabledMessage"
      class="hide-for-medium staged-rollout__alert"
    >
      {{ this.$t('APP.RELEASES.STAGED_ROLLOUT.INSTALLS_LIMIT') }}
    </span>
  </div>
</template>

<script>
import StagedRolloutSlider from './StagedRolloutSlider';
import Hint from '@@/common/Hint';

export default {
  name: 'StagedRollout',
  components: { StagedRolloutSlider, Hint },
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    percentage: {
      type: Number,
      required: true,
    },
    showDisabledMessage: {
      type: Boolean,
      default: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: '',
      localPercentage: this.percentage,
    };
  },
  watch: {
    localPercentage(value) {
      this.$emit('update:percentage', value);
    },
    expanded: {
      immediate: true,
      handler(expanded) {
        this.isActive = expanded ? 'active' : '';
      },
    },
  },
};
</script>

<style lang="scss">
.staged-rollout {
  margin: $global-margin * 2 0;

  &__label-text {
    margin-right: calc($global-margin / 2);

    @include rtl() {
      margin-right: 0;
      margin-left: calc($global-margin / 2);
    }
  }

  &__slider {
    padding: 0 $global-padding * 0.6;
  }

  &__alert {
    color: $lb-color-warning;
    margin-left: $global-margin;
    font-size: 0.8rem;
    @include rtl() {
      margin-left: auto;
      margin-right: $global-margin;
    }
  }
}
</style>
